import {
  Box,
  Button,
  Divider,
  Flex,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Switch,
  Text,
  Tooltip,
  useBoolean,
} from '@chakra-ui/react';
import { ReactComponent as SettingsIcon } from 'assets/icons/toolbar/file/gear.svg';
import { useUser } from 'modules/User';
import { PopoverWrapper } from 'modules/common/components/ToolbarPopover/PopoverWrapper';
import { ImageTag, ImageWidgetData } from 'widgets/ImageWidget/ImageWidget.types';
import { useWidget } from 'widgets/sdk';

/**
 * Used for admin users to set image tags
 */
const AdminWidgetProps = () => {
  const { isAdminUser } = useUser();

  const [isOpen, setIsOpen] = useBoolean();

  const { tags = [], updateWidget } = useWidget<ImageWidgetData>();

  const onChangeIsLogo = () => {
    if (tags.includes('logo')) {
      updateWidget({ tags: tags.filter((tag) => tag !== 'logo') });
      return;
    }
    updateWidget({ tags: [...new Set<ImageTag>([...tags, 'logo'])] });
  };

  if (!isAdminUser) return null;

  return (
    <PopoverWrapper>
      <Popover isLazy placement='bottom-start' isOpen={isOpen} onClose={setIsOpen.off} closeOnBlur>
        <Tooltip label='Widget Properties - Only for admin users' hasArrow>
          <Box>
            <PopoverTrigger>
              <Button
                size='sm'
                onClick={setIsOpen.on}
                fontWeight='semibold'
                variant='ghost-with-active'
                data-testid='img_toolbar-edit_image'
                textTransform={'capitalize'}
                isActive={isOpen}
              >
                <SettingsIcon />
              </Button>
            </PopoverTrigger>
          </Box>
        </Tooltip>
        <PopoverContent>
          <PopoverBody p={0}>
            <Flex flexDirection='column' p={4} gap={2}>
              <Flex>
                <Text fontSize={'sm'}>Widget Properties - Only for admin users</Text>
              </Flex>
              <Divider />
              <Flex flexDir='row' justifyContent='space-between' flexGrow={1} pt={2}>
                <Text fontSize='sm' lineHeight='1.25' color={'font.300'} as={'label'} htmlFor='is-logo'>
                  Image is a logo{' '}
                  <Text as={'span'} fontSize={'xs'}>
                    (Used for Brand Kit)
                  </Text>
                </Text>
                <Switch isChecked={tags.includes('logo')} onChange={onChangeIsLogo} id='is-logo' />
              </Flex>
            </Flex>
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </PopoverWrapper>
  );
};

export default AdminWidgetProps;
